.root {
  // Aligns with antd Modal default width (520px) — InfoPopover is a small
  // content panel for prose, so it borrows the system's "small content
  // panel" width as its readability cap.
  max-width: 520px;
}

.icon {
  cursor: pointer;
  font-size: 15px;
  margin: 1px;
}
